const ENDECASEARCH_API_URL = '/search/terms/';
const ENDECASEARCH_RESULT_URL = '/search/?page=1&q=';
const SEARCH_URL = 'search-service-autosuggest/predictivesearch';

const CHANNEL = {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    DESKTOP: 'desktop',
};

const DEFAULT_SHIP_TO_COUNTRY = 'US';

export default {
    ENDECASEARCH_API_URL,
    ENDECASEARCH_RESULT_URL,
    SEARCH_URL,
    CHANNEL,
    DEFAULT_SHIP_TO_COUNTRY,
};
